import {
  getPrivateMessageRecent,
  getPrivateMessagesFree,
  getPrivateMessageThread,
  PRIVATE_MESSAGE_EVENTS,
  ROLE_GROUPS,
  ROLES
} from '@moal/api'
import { useContext, useEffect } from 'react'
import {
  ADD_MESSAGE,
  DELETE_MESSAGE,
  EDIT_MESSAGE,
  EDIT_USER,
  INITIAL_LOAD,
  LOAD_MORE
} from '../constants/actions/messageListActions'
import { MODERATORS } from '../constants/chatRooms'
import { SocketContext } from '../context/socketContext'
import { PRODUCT_CODE } from '../utils/ENV'

export const usePrivateMessages = (
  user,
  userId,
  channel,
  dispatch,
  modView,
  history
) => {
  const { privateMessagesSocket } = useContext(SocketContext)

  useEffect(() => {
    if (channel === MODERATORS && privateMessagesSocket) {
      privateSockets()
    } else if (privateMessagesSocket) {
      privateSockets(false)
    }
    return () => {
      if (privateMessagesSocket) {
        privateSockets(false)
      }
    }
  }, [privateMessagesSocket, channel])

  const privateSockets = (on = true) => {
    if (on) {
      privateMessagesSocket.on(
        PRIVATE_MESSAGE_EVENTS.POST,
        handleNewPrivateMessage
      )
      privateMessagesSocket.on(
        PRIVATE_MESSAGE_EVENTS.EDIT,
        handleEditedPrivateMessage
      )
      privateMessagesSocket.on(
        PRIVATE_MESSAGE_EVENTS.DELETE,
        handleDeletedPrivateMessage
      )
      privateMessagesSocket.on(
        PRIVATE_MESSAGE_EVENTS.UPDATE_USER,
        handleEditedPrivateMessageUser
      )
    } else {
      privateMessagesSocket.off(
        PRIVATE_MESSAGE_EVENTS.POST,
        handleNewPrivateMessage
      )
      privateMessagesSocket.off(
        PRIVATE_MESSAGE_EVENTS.EDIT,
        handleEditedPrivateMessage
      )
      privateMessagesSocket.off(
        PRIVATE_MESSAGE_EVENTS.DELETE,
        handleDeletedPrivateMessage
      )
      privateMessagesSocket.off(
        PRIVATE_MESSAGE_EVENTS.UPDATE_USER,
        handleEditedPrivateMessageUser
      )
    }
  }

  const handleNewPrivateMessage = (data) => {
    if (data.toEveryone && data.itemNumber === PRODUCT_CODE) {
      dispatch({ type: ADD_MESSAGE, payload: data })
    } else if (
      user.userService._id !== data.user.userService._id && // we don't need to render it for the sender again
      renderPrivateMessage({
        modIsLookingAt: userId,
        senderPrivateMessages: data.user._id,
        receiverPrivateMessages: data?.toUser?._id,
        messageItemNumber: data.itemNumber
      })
    ) {
      dispatch({ type: ADD_MESSAGE, payload: data })
    }
  }

  const handleEditedPrivateMessage = (data) => {
    if (data.toEveryone && data.itemNumber === PRODUCT_CODE) {
      dispatch({ type: EDIT_MESSAGE, payload: data })
    } else if (
      !user ||
      (user.role.role === ROLES.SUBSCRIBER &&
        user.userService._id !== data.user.userService._id)
    ) {
      // if a message was "toEveryone" and is edit sets that back to false we need to remove it from all other users feed
      dispatch({ type: DELETE_MESSAGE, payload: data })
    } else if (
      renderPrivateMessage({
        modIsLookingAt: userId,
        senderPrivateMessages: data.user._id,
        receiverPrivateMessages: data?.toUser?._id,
        messageItemNumber: data.itemNumber
      })
    ) {
      dispatch({ type: EDIT_MESSAGE, payload: data })
    }
  }

  const handleDeletedPrivateMessage = (data) => {
    dispatch({ type: DELETE_MESSAGE, payload: data })
  }

  const renderPrivateMessage = ({
    modIsLookingAt, // private messages service id
    senderPrivateMessages, // private messages service id
    receiverPrivateMessages, // private messages service id
    messageItemNumber
  }) => {
    // if on the front end
    if (!modView) {
      const isSubscriber = !ROLE_GROUPS.STAFF.includes(user?.role?.role) // is the user a normal level
      const noReceiverMessages = receiverPrivateMessages === undefined // is it to the mods

      return (
        isSubscriber || // if they ARE a subscriber they only get messages sent to or from them anyway
        (!isSubscriber && noReceiverMessages) // if they AREN'T a subscriber and it's to a mod
      )
    } else if (history && messageItemNumber !== PRODUCT_CODE) {
      return false
    }

    // else on the back end
    return (
      modIsLookingAt === senderPrivateMessages || // mod is looking at sub and sub SENDS message
      modIsLookingAt === receiverPrivateMessages // mod is looking at sub and sub RECEIVES message
    )
  }

  const handleGetPrivateMessages = async ({
    initialLoad,
    messages,
    userId = null,
    search = null
  }) => {
    let loadMore = ''
    if (!initialLoad && messages.length > 0) {
      loadMore = messages[messages.length - 1].postDate
    }

    let response

    if (!localStorage.getItem('authToken')) {
      response = await getPrivateMessagesFree({
        itemNumber: PRODUCT_CODE,
        loadMore
      })
    } else {
      if (history) {
        response = await getPrivateMessageRecent({
          token: localStorage.getItem('authToken'),
          itemNumber: PRODUCT_CODE,
          loadMore,
          userId,
          search
        })
      } else {
        response = await getPrivateMessageThread({
          token: localStorage.getItem('authToken'),
          itemNumber: PRODUCT_CODE,
          loadMore,
          userId,
          search
        })
      }
    }

    if (response && response.status === 200) {
      if (initialLoad) {
        dispatch({ type: INITIAL_LOAD, payload: response.data })
      } else {
        dispatch({ type: LOAD_MORE, payload: response.data })
      }
    }
  }

  const handleEditedPrivateMessageUser = (data) => {
    {
      dispatch({ type: EDIT_USER, payload: data })
    }
  }

  return { handleGetPrivateMessages }
}
